import React from 'react';
import { useField } from 'formik';
import {
  Checkbox,
  CheckboxProps,
  FormControlLabel,
  styled,
} from '@mui/material';

interface iFormikField extends CheckboxProps {
  name: string;
  label?: string | React.ReactNode;
}

const MuiLabel = styled(FormControlLabel)(({ theme }) => ({
  alignItems: 'flex-start',

  '& .MuiCheckbox-root': {
    padding: theme.spacing(0.25),

    '& .MuiSvgIcon-root': {
      fontSize: 20,
      color: theme.palette.grey[400],
    },

    '&.Mui-checked': {
      '& .MuiSvgIcon-root': {
        color: theme.palette.primary.main,
      },
    },
  },

  '& .MuiTypography-root': {
    marginLeft: theme.spacing(1),
    fontSize: 12,
    fontWeight: 400,
    color: theme.palette.grey[600],
    userSelect: 'none',

    '& a': {
      color: theme.palette.primary.main,
      textDecoration: 'none',
      opacity: 0.8,
      transition: 'all 0.3s ease',

      '&:hover': {
        opacity: 1,
        color: theme.palette.text.primary,
      },
    },
  },
}));

const FormikCheckBox: React.FC<iFormikField> = ({ name, label, ...props }) => {
  const [field, meta] = useField(name);

  const { value } = meta;
  const { onChange } = field;

  return (
    <MuiLabel
      control={
        <Checkbox
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          {...props}
        />
      }
      label={label}
    />
  );
};

export default FormikCheckBox;
